module.exports = __webpack_public_path__ + "img/Preparation.7bcb81aa.jpeg";